import { render, staticRenderFns } from "./AgendaListTable.vue?vue&type=template&id=601feb52&scoped=true"
import script from "./AgendaListTable.vue?vue&type=script&lang=js"
export * from "./AgendaListTable.vue?vue&type=script&lang=js"
import style0 from "./AgendaListTable.vue?vue&type=style&index=0&id=601feb52&prod&lang=scss"
import style1 from "./AgendaListTable.vue?vue&type=style&index=1&id=601feb52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601feb52",
  null
  
)

export default component.exports